import {Draggable, gsap, InertiaPlugin} from "gsap/all";
import seedrandom from "seedrandom"
import $ from "jquery";

const complexPositons = [
  {
    x: 590,
    y: 550
  }, {
    x: 1000,
    y: 500
  }, {
    x: 1600,
    y: 620
  }
]

export class AnimationSceneMolecule {

  constructor(atoms, position) {
    this.tl = null;
    this.atoms = atoms;
    this.targetPosition = position;
  }

  bind() {
    this.resetTimeline();

    const baseOptions = {
      ease: "sine.inOut",
      duration: 1,
    }

    for (const [i, atom] of this.atoms.entries()) {
      // gsap.set(atom.$el, {zIndex: this.atoms.length - i + 10});
      if (i === 0) this.tl.to(atom.$el, {x: this.targetPosition.x, y: this.targetPosition.y, ...baseOptions}, 0);
      if (i === 1) this.tl.to(atom.$el, {x: this.targetPosition.x - 20, y: this.targetPosition.y + 20, ...baseOptions}, 0);
      if (i === 2) this.tl.to(atom.$el, {x: this.targetPosition.x + 20, y: this.targetPosition.y - 20, ...baseOptions}, 0);
      atom.$el.addClass("bound")
    }
  }

  buildComplex(spotIndex, delta) {
    this.resetTimeline()

    const baseOptions = {
      ease: "sine.inOut",
      duration: 1,
      immediateRender: false,
    }

    const spotPos = complexPositons[spotIndex];
    const deltaOffset = {
      x: (delta % 2 === 1) ? -75 : (delta % 2 === 2) ? 75 : 0,
      y: (delta === 1) ? -60 : (delta === 2) ? 60 : (delta === 3) ? -120 : (delta === 5) ? 120 : 0,
    };

    for (const [i, atom] of this.atoms.entries()) {
      if (i === 0) this.tl.to(atom.$el, {x: spotPos.x + deltaOffset.x, y: spotPos.y + deltaOffset.y, ...baseOptions}, 0);
      if (i === 1) this.tl.to(atom.$el, {x: spotPos.x + deltaOffset.x - 30, y: spotPos.y + deltaOffset.y + 30, ...baseOptions}, 0);
      if (i === 2) this.tl.to(atom.$el, {x: spotPos.x + deltaOffset.x + 30, y: spotPos.y + deltaOffset.y - 30, ...baseOptions}, 0);
      atom.$el.addClass("bound")
    }

  }

  unbind() {
    this.resetTimeline()

    for (const atom of this.atoms) {
      this.tl.to(atom.$el, {
        x: atom.initialX, y: atom.initialY,
        ease: "sine.inOut",
        duration: 0.7 + (Math.random() * 0.3),
      }, 0);
    }

    this.tl.add(() => {
      for (const atom of this.atoms) {
        atom.$el.css("z-index", "auto");
        atom.$el.removeClass("bound")
      }
    })
  }

  resetTimeline() {
    if (this.tl) {
      this.tl.kill();
      this.tl = null;
    }
    this.tl = gsap.timeline();
  }

  reset() {
    this.resetTimeline()

    for (const atom of this.atoms) {
      atom.$el.removeClass("bound")
    }
  }

}

